import axios from "../../../utils/authAxios";
const api_base_url = process.env.REACT_APP_API_BASEURL;

export const getEmployeeType = async () => {
  const { data } = await axios.get(
    `${api_base_url}/EmployeeConfiguration/EmployeeType`
  );
  return data;
};

export const getEmployeeTypeFilter = async () => {
  const { data } = await axios.get(
    `${api_base_url}/EmployeeConfiguration/EmployeeTypeFilter`
  );

  return data;
};

// Insert New EmployeeType
export const addEmployeeType = async (newEmployeeType) => {
  const { data } = await axios.post(
    `${api_base_url}/EmployeeConfiguration/EmployeeType`,
    {
      ...newEmployeeType[0],
    }
  );
  return data;
};
// Update EmployeeType

export const updateEmployeeType = async (updatedEmployeType) => {
  const { data } = await axios.put(
    `${api_base_url}/EmployeeConfiguration/EmployeeType${updatedEmployeType[0].employeeTypeId}`,
    updatedEmployeType[0]
  );
  return data;
};

export const deleteEmployeeTypes = async (ids) => {
  await axios.delete(`${api_base_url}/EmployeeConfiguration/EmployeeType`, {
    data: ids,
  });
};
